export const IconUrl = 'https://openweathermap.org/img/wn/';

export enum MEDIA_GATES {
  tablet = 765,
  desktop = 1000,
}